import React from "react";
import { ReactComponent as Heart } from "../icons/heart.svg";
import { ReactComponent as CupCakes } from "../icons/cupcake.svg";
import { ReactComponent as Cakes } from "../icons/birthcake.svg";
import { ReactComponent as IceCream } from "../icons/ice-cream.svg";
import { ReactComponent as Drinks } from "../icons/drink.svg";
import { ReactComponent as Salad } from "../icons/salad.svg";

const iconComponents = [
  <Heart />,
  <Cakes />,
  <CupCakes />,
  <Drinks />,
  <IceCream />,
  <Salad />,
];
export default iconComponents;
